import {
  type EntityId,
  type EntityKind,
  type PrivacyClass,
  type RecordEnvelope,
  type SourceRecordId,
  newEntityId,
} from '@life-os/app-core';
import type { Clock } from './clock.js';

export interface NewEnvelopeArgs {
  readonly kind: EntityKind;
  readonly ownerId: string;
  readonly privacyClass: PrivacyClass;
  readonly sourceRecordId?: SourceRecordId | null;
}

/** Build a fresh envelope: localVersion=1, never synced, active, immutable createdAt. */
export function createEnvelope(args: NewEnvelopeArgs, clock: Clock): RecordEnvelope {
  const now = clock.nowIso();
  return {
    id: newEntityId(),
    kind: args.kind,
    ownerId: args.ownerId,
    privacyClass: args.privacyClass,
    createdAt: now,
    updatedAt: now,
    localVersion: 1,
    baseVersion: null,
    lifecycle: 'active',
    sourceRecordId: args.sourceRecordId ?? null,
  };
}

/**
 * Produce the next envelope for an update: bump localVersion + updatedAt,
 * preserve createdAt and id (chronology invariant). The id type is preserved.
 */
export function bumpEnvelope<T extends RecordEnvelope>(existing: T, clock: Clock): T {
  return {
    ...existing,
    updatedAt: clock.nowIso(),
    localVersion: existing.localVersion + 1,
  };
}

export type { EntityId };
